import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { accountRoles, accountRegistrationStatuses } from '../../../common/enums';
import { normalizeString } from '../../../common/utils/helpers';
import { AccountList } from '../components';
import { apiCallIds } from '../api';
import {
  fetchAccountsActions,
  selectAccounts,
  selectAccountsFilter,
  selectAccountsPagination,
  setAccountsFilterAction,
} from '../ducks';

const mapStateToProps = state => ({
  accounts: selectAccounts(state),
  filter: selectAccountsFilter(state),
  token: selectToken(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_ACCOUNTS),
  pagination: selectAccountsPagination(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccounts: fetchAccountsActions.request,
      setFilter: setAccountsFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  registrationStatus: accountRegistrationStatuses.DOCUMENTS_SUBMITTED,
  role: [accountRoles.DEBTOR, accountRoles.CREDITOR],
  search: '',
  locked: false,
};

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountListContainer extends Component {
  static propTypes = {
    accounts: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
    actions.fetchAccounts(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { actions, filter } = this.props;
    actions.fetchAccounts({
      ...filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterRoleChange = roles => {
    if (roles.length > 0) {
      this.onFilterChange('role')(roles);
    }
  };

  onFilterLockedChange = e => {
    this.onFilterChange('locked')(e.target.checked);
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      search: normalizeString(filterValue),
      registrationStatus: '',
    });
  };

  onFilterStatusChange = this.onFilterChange('registrationStatus');

  render() {
    const { accounts, filter, isLoading, pagination, token } = this.props;

    return (
      <AccountList
        accounts={accounts}
        filter={filter}
        isLoading={isLoading}
        onFilterRoleChange={this.onFilterRoleChange}
        onFilterLockedChange={this.onFilterLockedChange}
        onFilterSearchChange={this.onFilterSearchChange}
        onFilterStatusChange={this.onFilterStatusChange}
        onTableChange={this.handleTableChange}
        pagination={pagination}
        token={token}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountListContainer.js